//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AlertBox',
  props: {
    leftText: {          // 左按钮文本
      type: String,
      default: '取消'
    },
    rightText: {         // 右按钮文本
      type: String,
      default: '确定'
    },
    title: {             // 标题
      type: String,
      default: ''
    },
    content: {           // 内容
      type: String,
      default: '1231231312312'
    },
    alertBol: {          // 弹窗控制变量
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 左按钮事件
    leftBtn () {
      this.$emit('leftBtn')
    },
    // 右按钮事件
    rightBtn () {
      this.$emit('rightBtn')
    },
    trimStr (str) {
      return str.replace(/(^\s*)|(\s*$)/g, '')
    }
  },
  mounted () {
    console.log(this.content)
    // alert(this.content)
  }
}



// WEBPACK FOOTER //
// ./src/components/common/alert-box.vue